import api from '../../plugins/api';

// GET /api/crm/cars/stockImport/runs/{id} â Ð¿ÑÐ¾Ð³Ð¾Ð½ ÑÐ¾ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ Ð½Ðµ Ð·Ð°ÐµÑÐ°Ð²ÑÐ¸Ñ ÑÑÑÐ¾Ðº.
const getStockImportRun = (id) => {
  return api.get(`/api/crm/cars/stockImport/runs/${id}`);
};

export default getStockImportRun;
